export default __webpack_public_path__ + "static/media/BCAmber.5ce641ab.webp";